export const css = {
    root: '_1sMG2xxv',
    title: '_37dmarQh',
    progressBar: '_2jD6wguT',
    legend: 'M5yqbzX4',
    ' _key': 'progress-bar/line'
};
export default css;
